<template>
  <div style="text-align: center">
    <div>
      <div class="social-icons">
        <div class="social-icon-container zoom">
          <a href="https://www.reddit.com/user/ATH_Games" target="_blank">
            <img src="../assets/img/logos/Reddit_Logo.png" alt="" />
            <p>REDDIT</p></a
          >
        </div>
        <div class="social-icon-container zoom">
          <a href="https://t.me/joinchat/JcZxMw2MLUoyYmE8" target="_blank">
            <img src="../assets/img/logos/Telegram_Logo.png" alt="" />
            <p>TELEGRAM</p>
          </a>
        </div>
        <div class="social-icon-container zoom">
          <a href="https://www.instagram.com/athgames/" target="_blank">
            <img src="../assets/img/logos/Instagram_Logo.png" alt="" />
            <p>INSTAGRAM</p>
          </a>
        </div>
        <div class="social-icon-container zoom">
          <a href="https://discord.gg/ZyjFfNnF2B" target="_blank">
            <img src="../assets/img/logos/Discord_Logo.png" alt="" />
            <p>DISCORD</p></a
          >
        </div>
        <div class="social-icon-container zoom">
          <a href="https://twitter.com/ath_games" target="_blank">
            <img src="../assets/img/logos/Twitter_Logo.png" alt="" />
            <p>TWITTER</p></a
          >
        </div>
      </div>
    </div>
    <a href="https://linktr.ee/ATH_Games" target="_blank">
      <img
        class="link-tree content-bottom-margin"
        style="width: 10vw; margin-top: 1vw"
        src="../assets/img/logos/Linktree_Logo.png"
        alt=""
    /></a>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.link-tree {
  width: 15vw;
}

.social-icon-container img {
  width: 4vw;
  height: 4vw;
}

.social-icons {
  font-size: clamp(4px, 1vw, 2rem);
  display: grid;
  justify-content: center;
  grid-template-columns: repeat(5, 7em);
  grid-column-gap: 3em;
}

.social-icons a {
  text-decoration: none !important;
}

@media (max-width: 992px) {
  .social-icons {
    grid-column-gap: 1em;
  }
}
</style>
